import { gEnums } from 'global/enums/globalEnums';
import { arrayUpdateToDatabase } from 'global/firestoreData/updates/arrays/arrayUpdates';
import { useCallback, useContext, useState } from 'react'
import { ParentContext } from '../ParentContext';

export const useArrayUpdate = () => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states ?? {}

  const [updating, setUpdating] = useState()

  const updateArrayToDatabase = useCallback(async ({ actionItem }) => {

    const cb = () => setUpdating(false)

    const uProps = {
      actionItem: actionItem,
      dispatch: cb,
      dataActionType: gEnums.itemLinkTypes.linkProfile,
      paps_state,
      remove: actionItem.remove
    }

    setUpdating(true)
    arrayUpdateToDatabase(uProps)

  }, []);

  return { updateArrayToDatabase, updating }
}
